import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

import { SeFeCardModule } from 'se-fe-card'
import { SeHouseholdSetupFeatureParentGuardianInfoModule } from '../lib/se-household-setup-feature-parent-guardian-info.module'
import { ParentGuardianInfoDocsComponent } from './parent-guardian-info-docs/parent-guardian-info-docs.component'
import { PROVIDERS } from './providers'

@NgModule({
  declarations: [ParentGuardianInfoDocsComponent],
  exports: [ParentGuardianInfoDocsComponent],
  imports: [
    CommonModule,
    SeFeCardModule,
    SeHouseholdSetupFeatureParentGuardianInfoModule
  ],
  providers: PROVIDERS
})
export class SeHouseholdSetupFeatureParentGuardianInfoDocsModule {}
